import React from 'react';
import { DownloadIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutUrl, finalCtaButton, finalCtaTitle } from '../data/content';
interface FinalCtaProps {
  showUrgency?: boolean;
}
export function FinalCta({
  showUrgency = true
}: FinalCtaProps) {
  return <section className="w-full bg-night-900 py-16 md:py-24" data-id="element-57" data-mp="15fq5k1m7my3g">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-58" data-mp="1jbk71zknml6j">
        {showUrgency && <CountdownPanel showScarcity={false} data-id="element-59" data-mp="1ed0mo3lplhga" />}

        <div className={`mx-auto max-w-2xl text-center ${showUrgency ? 'mt-14' : ''}`} data-id="element-60" data-mp="1ec7jtdpvfc3f">
          <h2 className="font-display text-[2rem] font-bold leading-[1.15] tracking-tight text-ink md:text-[2.75rem]" data-id="element-61" data-mp="1t50zaz557s83">
            {finalCtaTitle}
          </h2>

          <div className="mt-10" data-id="element-62" data-mp="224ed240av2ym">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-63" data-mp="221juyj4rdu8d">
              {finalCtaButton}
            </CtaButton>
          </div>

          <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-muted" data-id="element-64" data-mp="n6e2nf8ng5t7">
            <li className="inline-flex items-center gap-2" data-id="element-65" data-mp="s5gyc92qozoi">
              <LockIcon className="h-4 w-4 text-indigo-400" strokeWidth={1.75} aria-hidden="true" data-id="element-66" data-mp="x41xe5699dbd" />{' '}
              Pago único y seguro
            </li>
            <li className="inline-flex items-center gap-2" data-id="element-67" data-mp="1246fu0qq4i48">
              <DownloadIcon className="h-4 w-4 text-indigo-400" strokeWidth={1.75} aria-hidden="true" data-id="element-68" data-mp="1658gmm0ah28b" />{' '}
              Acceso inmediato
            </li>
            <li className="inline-flex items-center gap-2" data-id="element-69" data-mp="1fvl0ec0a4rde">
              <ShieldCheckIcon className="h-4 w-4 text-gold-400" strokeWidth={1.75} aria-hidden="true" data-id="element-70" data-mp="1kt3ai5q19cmz" />{' '}
              Garantía de por vida
            </li>
          </ul>
        </div>
      </div>
    </section>;
}